<template>
  <div
    class="dark:bg-ontick-graphite-500 bg-ontick-steel-100 overflow-y-auto rounded-lg"
  >
    <new-list-header-component :headers="headers" :nameColSpan="nameColSpan" />
    <new-list-body-component
      :investments="investments"
      :nameColSpan="nameColSpan"
      :headers="headers"
      @electronicSignature="$emit('electronicSignature', $event)"
    />
  </div>
</template>

<script>
import NewListBodyComponent from "./new-list-body.component.vue";
import newListHeaderComponent from "./new-list-header.component.vue";
import headers from "./headers";
import event_bus from "../../../../../shared/utils/event_bus";

export default {
  components: { newListHeaderComponent, NewListBodyComponent },

  props: {
    investments: {
      type: Array,
    },
  },

  data() {
    return {
      headers,
    };
  },

  computed: {
    nameColSpan() {
      if (
        this.headers.find((item) => item.key === "max_daily_loss").active ||
        this.headers.find((item) => item.key === "max_daily_gain").active
      ) {
        return 1;
      }
      return 2;
    },
  },

  mounted() {
    event_bus.$on("UPDATE_LIST_COLUMNS", (event) => {
      this.headers
        .filter((header) => header.optional)
        .forEach((header) => {
          if (event.includes(header.key)) {
            header.active = true;
          } else {
            header.active = false;
          }
        });
    });
  },
};
</script>

<style></style>
